import {Model} from "@vuex-orm/core";

export default class PushNotification extends Model {

    static entity = 'userPushNotifications';

    static fields () {
        return {
            id: this.uid(),
            component: this.attr('Message'),
            closable: this.boolean(true),
            timeout: this.number(5000).nullable(),
            color: this.attr('primary'),
            position: this.attr('right'),
            data: this.attr({}),
        }
    }

    static async phoneChecklist() {
        if (this.query().where('component', 'PhoneChecklist').exists()) {
            return;
        }

        return this.insert({
            data: {
                component: 'PhoneChecklist',
                timeout: null,
                position: 'left',
            }
        });
    }

    static async success(title, text = '') {
        return this.insert({
            data: {
                color: 'success',
                timeout: 3000,
                data: {
                    title: title,
                    text: text,
                    icon: 'mdi-check-circle-outline',
                }
            }
        });
    }

    static async warning(title, text = '') {
        return this.insert({
            data: {
                color: 'warning',
                timeout: 3000,
                data: {
                    title: title,
                    text: text,
                    icon: 'mdi-alert-outline',
                }
            }
        });
    }

    static async error(title, text = '') {
            return this.insert({
                data: {
                    color: 'error',
                    timeout: 30000,
                    data: {
                        title: title,
                        text: text,
                        icon: 'mdi-alert-octagon-outline',
                    }
                }
            });
    }

    static async info(title, text = '') {
        return this.insert({
            data: {
                color: 'info',
                timeout: 3000,
                data: {
                    title: title,
                    text: text,
                    icon: 'mdi-information-outline',
                }
            }
        });
    }
}
